import {Button, Space} from 'antd';
import {ModalContent, ModalFooter} from 'components/EnableSmsMFA/Shared';
import {FormItem, PhoneNumberInput} from 'components/Form';
import {Formik} from 'formik';
import {Form, SubmitButton} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import React from 'react';
import * as yup from 'yup';

export type InitFormValues = {
  phoneNumber: string;
};

type Props = {
  onSubmit: (values: InitFormValues) => Promise<void>;
  phoneNumber: string;
  onCancel: () => void;
};

export const Init: React.FC<Props> = ({onSubmit, onCancel, phoneNumber}) => {
  const schema = yup.object().shape({
    phoneNumber: yup.string().required()
  });

  const handleSubmit = async (
    values: InitFormValues,
    {setSubmitting, setErrors}: FormikHelpers<InitFormValues>
  ) => {
    try {
      await onSubmit(values);
    } catch (error) {
      setSubmitting(false);
      setErrors({phoneNumber: error.message});
    }
  };

  return (
    <>
      <Formik onSubmit={handleSubmit} initialValues={{phoneNumber}} validationSchema={schema}>
        <Form layout="vertical">
          <ModalContent>
            <p>
              We'll text a verification code to this mobile device whenever you sign in to your
              account.
            </p>
            <FormItem name="phoneNumber" label="Mobile phone number">
              <PhoneNumberInput name="phoneNumber" countryCode="ES" />
            </FormItem>
          </ModalContent>
          <ModalFooter>
            <Space>
              <Button onClick={onCancel}>Cancel</Button>
              <SubmitButton disabled={false}>Confirm phone number</SubmitButton>
            </Space>
          </ModalFooter>
        </Form>
      </Formik>
    </>
  );
};
